import isPriorityExpired from './is-priority-expired.js';

export default function getTagLabel({ publicationDate, priority }, i18next) {
  if (isPriorityExpired(publicationDate)) {
    return '';
  }

  return priority ? i18next.t(priority, '') : '';
}
